import { createDefaultFileDownloadSettings } from './localFile.js';
import { normalizeHeaderVideos } from './localVideo.js';

export const VIDEO_HEADER_TYPE = 'video-header';

export function getVideoHeaderDefaults(extra = {}) {
	return normalizeVideoHeaderData({
		title: '',
		items: [],
		downloadSettings: createDefaultFileDownloadSettings(),
		...extra,
	});
}

export function normalizeVideoHeaderData(data = {}) {
	return normalizeHeaderVideos(data);
}

export function isVideoHeaderBlock(type) {
	return type === VIDEO_HEADER_TYPE;
}
